import umbraco from '~/lib/api/umbraco';
import { FilterDefaultsResponse } from '~/services/loop54/types';
import { getUrl } from '~/services/umbraco/utils';

export default function getFilterDefaults(signal: AbortSignal | undefined) {
    const url = getUrl('/filters/defaults');
    return umbraco.get(url, { signal }).json<FilterDefaultsResponse>();
}
